export type LowLevelAuthFlowError = {
  type: string;
  message?: string;
  upstreamErrorMessage?: string;
};

export abstract class AuthError extends Error {
  abstract readonly type: string;
  abstract toAuthError(): LowLevelAuthFlowError;
}

export class DuplicateAccountError extends AuthError {
  readonly type = 'DuplicateAccount' as const;
  readonly existingAccountId: number;

  constructor(existingAccountId: number) {
    super('Duplicate account');
    this.name = 'DuplicateAccountError';
    this.existingAccountId = existingAccountId;
  }

  toAuthError(): LowLevelAuthFlowError & { existingAccountId: number } {
    return { type: this.type, existingAccountId: this.existingAccountId };
  }
}

export class AuthenticateError extends AuthError {
  readonly type = 'AuthenticateError';
  upstreamErrorMessage?: string;

  constructor(message?: string, upstreamErrorMessage?: string) {
    super(message);
    this.name = 'AuthenticateError';
    this.upstreamErrorMessage = upstreamErrorMessage;
  }

  toAuthError(): LowLevelAuthFlowError {
    return {
      type: this.type,
      message: this.message,
      upstreamErrorMessage: this.upstreamErrorMessage,
    };
  }
}
